import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

function Fanpad() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Controlled Environment Fan and Pad Polyhouse | Kryzen Greenhouse Systems"
        description="Kryzen's Controlled Environment Fan and Pad Polyhouse ensures precise temperature, humidity, and airflow control — perfect for high-value crop cultivation in extreme climates using fan-pad cooling technology."
        keywords="fan and pad polyhouse, controlled environment greenhouse, kryzen polyhouse, climate-controlled farming, polyhouse with fan and pad, high-value crops polyhouse, greenhouse temperature control, fan pad system agriculture"
        canonical="https://alpha.kryzen.com/kryzen-exhaust-fan-pad-controlled-environment-polyhouse"
        ogTitle="Controlled Environment Fan and Pad Polyhouse"
        ogDescription="An advanced Kryzen polyhouse system with fan-pad cooling technology for year-round cultivation. Ideal for extreme climates and high-value farming."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752225955/exhaust_fan_jml2ql.jpg"
        twitterTitle="Controlled Environment Fan and Pad Polyhouse"
        twitterDescription="Discover Kryzen's advanced fan and pad polyhouse — a controlled climate farming system for year-round high-value crop production."
      />
      <div>
        <Slider
          heding={"Controlled Environment Fan and Pad Polyhouse "}
          paragraph={
            "A Controlled Environment Fan and Pad Polyhouse is an advanced type of polyhouse (or greenhouse) that provides precise control over temperature, humidity, and air circulation, making it ideal for growing high-value crops in areas with extreme or fluctuating weather conditions."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              kryzen controlled environment
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              A Controlled Environment Fan and Pad Polyhouse is an advanced type
              of polyhouse (or greenhouse) that provides precise control over
              temperature, humidity, and air circulation, making it ideal for
              growing high-value crops in areas with extreme or fluctuating
              weather conditions. This system uses a combination of fans and
              cooling pads to regulate the internal climate, ensuring optimal
              growing conditions year-round.
            </motion.p>
          </div>
          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideLeftToRight}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147218/mainframe_totggg.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Main Frame Material
                  </h5>
                  <motion.p
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    Constructed from high-quality hot-dip galvanized steel, our
                    structure boasts a Zinc-coating of 275g/m2, ensuring a
                    robust service life of over 20 years. The steel components
                    are assembled on-site without needing secondary processing.
                    Galvanized connectors and fasteners are designed to resist
                    rust for two decades, guaranteeing long-term durability and
                    reliability.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={scaleFade}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147339/out_ddbqic.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Covering Materials
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Our covering materials made up of LDPE, mLLDPE, EVA, EBA
                    with a tensile strength of 25 MPa offer excellent light
                    transmission, superior heat preservation, and strong tensile
                    strength. They provide economical rain, wind & sun
                    protection to plants, with a lifespan of 5-7 years, ensuring
                    cost-effectiveness without compromising on quality.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147630/nvph_knv1je.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Outside Shading System
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Engineered to provide optimal cooling and shading during the
                    summer, this system diffuses sunlight within the greenhouse,
                    effectively shielding crops from harmful sun glare and
                    ensuring consistent growth conditions. Shading systems are
                    utilized widely when you want to grow crops which are
                    locally climatically affected.
                  </motion.p>
                </div>
              </motion.div>
            </div>
          </div>
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase mt-7"
            >
              Product Parameters
            </motion.h1>

            <hr></hr>
          </div>
          <div
            className=" py-5"
            style={{
              background:
                "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
              color: "black",
              border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
              padding: "1rem",
              borderRadius: "0.25rem",
            }}
          >
            <div className="row">
              <div className="col-12">
                <h3 className="text-success fw-bold mb-4">
                  Technical Specifications
                </h3>
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <tbody>
                      <tr>
                        <th scope="row">Wind Load</th>
                        <td>0.5 KN/m²</td>
                      </tr>
                      <tr>
                        <th scope="row">Snow Load</th>
                        <td>0.35 KN/m²</td>
                      </tr>
                      <tr>
                        <th scope="row">Maximum Drainage Capacity</th>
                        <td>140 mm/h</td>
                      </tr>
                      <tr>
                        <th scope="row">Span Width</th>
                        <td>4m, 8m, 9.6m, 10.8m, 12.8m or customized</td>
                      </tr>
                      <tr>
                        <th scope="row">Column Spacing</th>
                        <td>4.0m, 8.0m or customized</td>
                      </tr>
                      <tr>
                        <th scope="row">Shoulder Height</th>
                        <td>3.0m – 6.0m or customized</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-12 mt-5">
                <p
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: "1.8",
                    color: "#444",
                  }}
                >
                  Plastic film Polytunnel is a simple type of protected
                  cultivation tunnelled greenhouse, which uses transparent
                  plastic films made of polymer materials such as polyethene and
                  polypropylene and connects each arch greenhouse into a whole
                  through the method of connecting wires and buildings. The
                  multi-span polytunnel or greenhouse connects the original
                  independent greenhouse with the original independent single
                  room model greenhouse through reasonable design, increasing
                  the insulation area of the greenhouse and improving its
                  performance
                </p>
              </div>
            </div>
          </div>

          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              Fan and Pad System
            </motion.h1>

            <hr></hr>
          </div>

          <div className="row g-5 align-items-stretch">
            {/* Left Column */}
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideLeftToRight}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752225955/exhaust_fan_jml2ql.jpg"
                  alt="Fan and Pad System?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "350px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Fan and Pad System
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Similar to a traditional polyhouse, a controlled environment
                    fan & pad is made of a frame covered with transparent or
                    translucent polyethylene plastic. The structure is often
                    reinforced to accommodate the fan, pad system, and other
                    climate control equipment.<br></br>Fan and Pad System :{" "}
                    <br></br>
                    <b>Cooling Pads :</b>
                    Typically placed on one side of the polyhouse, these are
                    made of specially designed cellulose material. Water flows
                    through the pads, cooling the air as it passes through them.{" "}
                    <br></br>
                    <b>Exhaust Fans :</b> Positioned on the opposite side of the
                    polyhouse, these fans pull air through the cooling pads and
                    the entire growing area, lowering the temperature inside.
                    This creates a cooling effect through evaporation.
                  </motion.p>
                </div>
              </motion.div>
            </div>
            {/* Right Column */}
            <div className="col-md-6">
              <motion.div
                className="card border-0 h-100 p-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752226361/fan-design_js8hi3.avif"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "350px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Fan installation diagram
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    <b>Temperature Control :</b> This system allows you to
                    maintain ideal temperatures for crop growth, even in
                    extremely hot or fluctuating external conditions.<br></br>
                    <b>Humidity Regulation :</b> Proper humidity levels are
                    maintained, which is crucial for sensitive crops, preventing
                    issues like fungal growth or plant stress.
                    <br></br>
                    <b>Extended Growing Season :</b>The ability to regulate the
                    internal environment extends the growing season and allows
                    for year-round production. <br></br>
                    <b>Higher Yields and Quality :</b> Crops grown in controlled
                    environments tend to have higher yields and better quality
                    due to the stable growing conditions.
                  </motion.p>
                </div>
              </motion.div>
            </div>
          </div>
          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              Optional Intelligent Polytunnel Add-ons
            </motion.h1>

            <hr></hr>
          </div>
          <div>
            <div
              className="container  py-5"
              style={{
                background:
                  "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
                color: "#000",
                border: "1px solid #c0e6b6",
                borderRadius: "8px",
                padding: "1rem",
              }}
            >
              <h3 className="text-success fw-bold mb-4">
                Optional Intelligent Polytunnel Add-ons
              </h3>

              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "25%" }}>Add-on</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Steel Structure</th>
                      <td>Hot-galvanized steel pipe</td>
                    </tr>
                    <tr>
                      <th scope="row">Greenhouse Glass</th>
                      <td>Different models can be selected</td>
                    </tr>
                    <tr>
                      <th scope="row">Sun-shading Net</th>
                      <td>
                        Summer shade, block rain, moisture, cooling,
                        winter/spring heat preservation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Cooling System</th>
                      <td>
                        The fan forms negative pressure and the water curtain
                        cools down
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Heating System</th>
                      <td>
                        Thermal insulation series, air heater, boiler and pipe
                        heating, air circulating fan
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Ventilation System</th>
                      <td>Side windows and cooling fans</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Water & Fertilizer Integrated Irrigation System
                      </th>
                      <td>
                        Sprinkler irrigation series, drip irrigation series,
                        intelligent mobile sprinkler irrigation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Automatic Control System</th>
                      <td>
                        Automatic control technology that can independently
                        drive intelligent machines to achieve control objectives
                        without human intervention
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Fill-in Light</th>
                      <td>
                        Easy assemble auto light deprivation blackout greenhouse
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Seedling Bed</th>
                      <td>Movable seeding bed</td>
                    </tr>
                    <tr>
                      <th scope="row">Hydroponics</th>
                      <td>
                        It is reusable, requires no nutrient additions, and is
                        both convenient and inexpensive.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">External & Internal Shading System</th>
                      <td>The gear rack drives the shading system</td>
                    </tr>
                    <tr>
                      <th scope="row">Photovoltaic System</th>
                      <td>For solar power generation</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752227984/38_llkso7.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    FAN-PAD POLY TUNNEL
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752228009/40_tkqdxg.jpg"
                  alt="HEAT TRAPPING CARBONATE"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HEAT TRAPPING CARBONATE
                  </h5>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752227928/kryzen-hp-1_wnabv5.jpg"
                  alt="EXHAUST HALL POLY CARBONATE"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    EXHAUST HALL POLY CARBONATE
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              Structure Comparision
            </motion.h1>

            <hr></hr>
          </div>
          <div>
            <div
              className="container  py-5"
              style={{
                background:
                  "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
                color: "#000",
                border: "1px solid #c0e6b6",
                borderRadius: "8px",
                padding: "1rem",
              }}
            >
              <h3 className="text-success fw-bold mb-4">
                Structure Comparision
              </h3>

              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "25%" }}>Features</th>
                      <th>Kryzen Structure</th>
                      <th>Others Structure</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Height of Structure</th>
                      <td>6.8M to 7.2M from Ground Level</td>
                      <td>6.2M to 6.5M from Ground Level</td>
                    </tr>
                    <tr>
                      <th scope="row">Side Ventilation</th>
                      <td>4 meters</td>
                      <td>2.5 meteres</td>
                    </tr>
                    <tr>
                      <th scope="row">Top Vent</th>
                      <td>1.2 to 1.4 meters</td>
                      <td>2.5 meteres</td>
                    </tr>
                    <tr>
                      <th scope="row">Pipe Quality and Galvanization</th>
                      <td>375 GSM to 400 GSM</td>
                      <td>150 GSM to 250 GSM</td>
                    </tr>
                    <tr>
                      <th scope="row">Nut Bolts and Connectors</th>
                      <td>
                        22 Micron Zinc Ferrous Coated<br></br>
                        Main Connectors are 5mm Coated (Zinc Coating)
                      </td>
                      <td>
                        No Coating / 2mm Coating<br></br>
                        Resulting in rusting in 6 months
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Foundation</th>
                      <td>
                        76mm Diameter<br></br>2mm Thickness<br></br>
                        Crimped Foundation gives more strength
                      </td>
                      <td>
                        63mm Diameter<br></br>
                        1.6mm Thickness<br></br>Point Load Foundation is less
                        stable
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default Fanpad;
